import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, computed, watch } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import SelectOperator from '@/components/SelectOperator.vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { upsertHlhtConfig } from '@/api/operation'
import { ElMessage } from 'element-plus'
import AdvancedSettingContainer from '@/components/AdvancedSettingContainer.vue'
import InfoTooltip from '@/components/InfoTooltip.vue'
import { HLHTProtocol } from '@/types/types'


import { defineComponent, nextTick } from 'vue'
import FormRulesFactory from '@/common/formRules'

const __default__ = defineComponent({
  name: 'HlhtUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
  },
  info: {
    type: Object,
    default() {
      return {}
    },
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { expose, emit }) {

const props = __props

const evseFormRules = ref({
  ...FormRulesFactory.generateCustomRules(
    [
      'name',
      'cSecret.OperatorID',
      'cSecret.OperatorSecret',
      'cSecret.DataSecret',
      'cSecret.DataSecretIV',
      'cSecret.SigSecret',
      'sSecret.OperatorID',
      'sSecret.OperatorSecret',
      'sSecret.DataSecret',
      'sSecret.DataSecretIV',
      'sSecret.SigSecret',
      'sSecret.URL',
    ],
    'inputEmpty',
    'inputInvalid',
  ),
})
// console.log('🚀 ~ evseFormRules:', evseFormRules.value)

const { HLHTProtocols } = useProtocolEnums()

const { tl, t } = useI18nTl('Evses')



let subsForm = ref()
const record = ref<Record<string, any>>({})
const clearValidate = () => {
  console.log('clearValidate')
  nextTick(() => {
    let t = setTimeout(() => {
      clearTimeout(t)
      subsForm.value?.clearValidate()
    }, 300)
  })
}
const showDialog = computed({
  get: () => {
    clearValidate()
    return props.modelValue
  },
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})
const handleOperatorSelect = (item: any) => {
  console.log('item======== operator select', item)
  record.value.stationID = ''
  record.value.stationName = ''
}

const submit = async () => {
  await subsForm.value?.validate()
  const processedRecord = ref({ ...record.value })
  upsertHlhtConfig(processedRecord.value)
    .then((res: any) => {
      if (props.isEdit) {
        ElMessage.success(t(`Base.editSuccess`))
      } else {
        ElMessage.success(t(`Base.createSuccess`))
      }

      showDialog.value = false
      record.value = {}
      emit('submitted')
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}

watch(
  () => props.modelValue,
  (val) => {
    if (props.isEdit) {
      console.log('props.evseInfo', props.info)
      record.value.id = props.info?.id
      record.value.operatorId = props.info?.operatorId
      record.value.operatorName = props.info?.operatorName
      record.value.name = props.info?.name
      record.value.desc = props.info?.desc
      record.value.seflPlatfromType = props.info?.seflPlatfromType //stationName 将站点修改成站点名称
      record.value.protocol = props.info?.proto
      record.value.cSecret = props.info?.cSecret
      record.value.sSecret = props.info?.sSecret
      record.value.enableCTokenExpire = props.info?.enableCTokenExpire
      record.value.enableSTokenExpire = props.info?.enableSTokenExpire
      record.value.funcs = props.info?.funcs
    } else {
      record.value = {
        protocol: 0,
        cSecret: {
          OperatorID: '',
          OperatorSecret: '',
          DataSecret: '',
          DataSecretIV: '',
          SigSecret: '',
          URL: '',
        },
        sSecret: {
          OperatorID: '',
          OperatorSecret: '',
          DataSecret: '',
          DataSecretIV: '',
          SigSecret: '',
          URL: '',
        },
      }
    }
  },
  { immediate: true },
)

expose({
  clearValidate,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: props.isEdit ? _unref(t)('Operation.editHlhtConfig') : _unref(t)('Operation.addHlhtConfig'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "evse-drawer",
    "destroy-on-close": true
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[34] || (_cache[34] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.isEdit ? _ctx.$t('Base.edit') : _ctx.$t('Base.add')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        rules: evseFormRules.value,
        ref_key: "subsForm",
        ref: subsForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "name",
                    label: _unref(t)('Base.name'),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "operatorId"
                  }, {
                    default: _withCtx(() => [
                      (!props.isEdit)
                        ? (_openBlock(), _createBlock(SelectOperator, {
                            key: 0,
                            modelValue: record.value.operatorId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.operatorId) = $event)),
                            onChanges: handleOperatorSelect
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            modelValue: record.value.operatorName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.operatorName) = $event)),
                            disabled: true
                          }, null, 8, ["modelValue"]))
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "protocol",
                    label: _unref(t)('Evses.protocol')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.protocol,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.protocol) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HLHTProtocols), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "desc",
                    label: _unref(t)('Base.remark')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 1,
                        modelValue: record.value.desc,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((record.value.desc) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (record.value.protocol == _unref(HLHTProtocol).HP_AMAP)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(AdvancedSettingContainer, {
                  title: _unref(t)('Operation.ourConfig')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { gutter: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "cSecret.OperatorID",
                              label: _unref(t)('Operation.hlhtOperatorID'),
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: record.value.cSecret.OperatorID,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((record.value.cSecret.OperatorID) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "cSecret.SigSecret",
                              label: _unref(t)('Operation.hlhtSigSecret'),
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: record.value.cSecret.SigSecret,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((record.value.cSecret.SigSecret) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "cSecret.URL",
                              label: _unref(t)('Operation.hlhtURL')
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.hlhtURL')), 1),
                                _createVNode(InfoTooltip, {
                                  content: _ctx.$t('Operation.hlhtURLTip')
                                }, null, 8, ["content"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: record.value.cSecret.URL,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((record.value.cSecret.URL) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(AdvancedSettingContainer, {
                  title: _unref(t)('Operation.tpConfig')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { gutter: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "sSecret.OperatorID",
                              label: _unref(t)('Operation.hlhtOperatorID'),
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: record.value.sSecret.OperatorID,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((record.value.sSecret.OperatorID) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "sSecret.SigSecret",
                              label: _unref(t)('Operation.hlhtSigSecret'),
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: record.value.sSecret.SigSecret,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((record.value.sSecret.SigSecret) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              prop: "sSecret.URL",
                              label: _unref(t)('Operation.hlhtURL'),
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: record.value.sSecret.URL,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((record.value.sSecret.URL) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["title"])
              ]))
            : (record.value.protocol == _unref(HLHTProtocol).HP_ALI)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(AdvancedSettingContainer, {
                    title: _unref(t)('Operation.ourConfig')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "cSecret.settlementId",
                                label: _unref(t)('Operation.hlhtSettlementId')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.cSecret.settlementId,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((record.value.cSecret.settlementId) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "cSecret.operatingCompanyId",
                                label: _unref(t)('Operation.hlhtOperatingCompanyId'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.cSecret.operatingCompanyId,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((record.value.cSecret.operatingCompanyId) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "cSecret.operatingCompanyName",
                                label: _unref(t)('Operation.hlhtOperatingCompanyName'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.cSecret.operatingCompanyName,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((record.value.cSecret.operatingCompanyName) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(AdvancedSettingContainer, {
                    title: _unref(t)('Operation.tpConfig')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.appid",
                                label: _unref(t)('Operation.appid'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.appid,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((record.value.sSecret.appid) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.secret",
                                label: _unref(t)('Operation.appSecret'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.secret,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((record.value.sSecret.secret) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.aliPublicKey",
                                label: _unref(t)('Operation.aliPublicKey'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.aliPublicKey,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((record.value.sSecret.aliPublicKey) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.aliEncryptKey",
                                label: _unref(t)('Operation.aliEncryptKey'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.aliEncryptKey,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((record.value.sSecret.aliEncryptKey) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.accessKeyId",
                                label: _unref(t)('Operation.mayiAccessKeyId'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.accessKeyId,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((record.value.sSecret.accessKeyId) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.accessKeySecret",
                                label: _unref(t)('Operation.mayiAccessKeySecret'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.accessKeySecret,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((record.value.sSecret.accessKeySecret) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.scene",
                                label: _unref(t)('Operation.scene'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.scene,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((record.value.sSecret.scene) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.endpoint",
                                label: _unref(t)('Operation.hlhtURL'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.endpoint,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((record.value.sSecret.endpoint) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(AdvancedSettingContainer, {
                    title: _unref(t)('Operation.ourConfig')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "cSecret.OperatorID",
                                label: _unref(t)('Operation.hlhtOperatorID'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.cSecret.OperatorID,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((record.value.cSecret.OperatorID) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "cSecret.OperatorSecret",
                                label: _unref(t)('Operation.hlhtOperatorSecret'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.cSecret.OperatorSecret,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((record.value.cSecret.OperatorSecret) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "cSecret.DataSecret",
                                label: _unref(t)('Operation.hlhtDataSecret'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.cSecret.DataSecret,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((record.value.cSecret.DataSecret) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "cSecret.DataSecretIV",
                                label: _unref(t)('Operation.hlhtDataSecretIV'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.cSecret.DataSecretIV,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((record.value.cSecret.DataSecretIV) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "cSecret.SigSecret",
                                label: _unref(t)('Operation.hlhtSigSecret'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.cSecret.SigSecret,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((record.value.cSecret.SigSecret) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "cSecret.URL",
                                label: _unref(t)('Operation.hlhtURL')
                              }, {
                                label: _withCtx(() => [
                                  _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.hlhtURL')), 1),
                                  _createVNode(InfoTooltip, {
                                    content: _ctx.$t('Operation.hlhtURLTip')
                                  }, null, 8, ["content"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.cSecret.URL,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((record.value.cSecret.URL) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(AdvancedSettingContainer, {
                    title: _unref(t)('Operation.tpConfig')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.OperatorID",
                                label: _unref(t)('Operation.hlhtOperatorID'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.OperatorID,
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((record.value.sSecret.OperatorID) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.OperatorSecret",
                                label: _unref(t)('Operation.hlhtOperatorSecret'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.OperatorSecret,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((record.value.sSecret.OperatorSecret) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.DataSecret",
                                label: _unref(t)('Operation.hlhtDataSecret'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.DataSecret,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((record.value.sSecret.DataSecret) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.DataSecretIV",
                                label: _unref(t)('Operation.hlhtDataSecretIV'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.DataSecretIV,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((record.value.sSecret.DataSecretIV) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.SigSecret",
                                label: _unref(t)('Operation.hlhtSigSecret'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.SigSecret,
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((record.value.sSecret.SigSecret) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "sSecret.URL",
                                label: _unref(t)('Operation.hlhtURL'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: record.value.sSecret.URL,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((record.value.sSecret.URL) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]))
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})